import { render, staticRenderFns } from "./img.vue?vue&type=template&id=3bf3d8fc&scoped=true&"
import script from "./img.vue?vue&type=script&lang=js&"
export * from "./img.vue?vue&type=script&lang=js&"
import style0 from "./img.vue?vue&type=style&index=0&id=3bf3d8fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf3d8fc",
  null
  
)

export default component.exports